import { CarCarePageContent } from '@cinch-nx/data-storyblok'
import {
  AdminFeeDrawerProvider,
  StoryblokRenderer,
} from '@in-life-and-loyalty/vaps-ui'

import styles from './vaps-feature-car-care.module.css'
import { useEffect, useState } from 'react'
import { ServicingSignInModal } from './components/sign-in-modal/servicing-sign-in-modal'
import { useUserStore } from '@cinch-nx/data-user'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export interface VapsFeatureCarCareProps {
  children?: React.ReactNode
  content: CarCarePageContent
}

const VapsFeatureCarCare: React.FC<VapsFeatureCarCareProps> = ({ content }) => {
  const { isLoggedIn } = useUserStore()
  const [openModal, setOpenModal] = useState<boolean>(false)
  const { trackEvent } = useAnalytics()
  const handleClick = (e: Event) => {
    e.preventDefault()

    trackEvent({
      eventName: `Click serivicing page link`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'car_maintenance',
          action: 'navigate to servicing page',
        },
      },
    })

    if (isLoggedIn()) {
      window.location.assign('/my-profile/servicing-and-mot')
      return
    } else {
      setOpenModal(true)
    }
  }

  useEffect(() => {
    document
      .querySelector("a[href='/my-profile/servicing-and-mot")
      ?.addEventListener('click', handleClick)
    return () => {
      document
        .querySelector("a[href='/my-profile/servicing-and-mot")
        ?.removeEventListener('click', handleClick)
    }
  }, [])

  if (!content) return null

  const onClose = () => setOpenModal(false)

  const wrappedComponents = content.body
    .map((el) => el.component)
    .filter(
      (el) =>
        el !== 'FeatureImageCardSection' &&
        el !== 'PeaceOfMind' &&
        el !== 'FeatureIconCardSection' &&
        el !== 'FeaturedEVsCarousel' &&
        el !== 'FinanceExample' &&
        el !== 'HowToGetCinchCharge',
    )

  const limitedItems: { [key: string]: number } = {}

  return (
    <article className={styles.mainSection}>
      <AdminFeeDrawerProvider>
        <StoryblokRenderer
          block={content.body}
          componentsWithWrapper={wrappedComponents}
          limitedItems={limitedItems}
        />
        {openModal && <ServicingSignInModal onClose={onClose} />}
      </AdminFeeDrawerProvider>
    </article>
  )
}

export default VapsFeatureCarCare
